import { render, staticRenderFns } from "./featuredCarousel.vue?vue&type=template&id=0421ede7&scoped=true"
import script from "./featuredCarousel.vue?vue&type=script&lang=js"
export * from "./featuredCarousel.vue?vue&type=script&lang=js"
import style0 from "./featuredCarousel.vue?vue&type=style&index=0&id=0421ede7&prod&lang=css"
import style1 from "./featuredCarousel.vue?vue&type=style&index=1&id=0421ede7&prod&lang=scss&scoped=true"
import style2 from "./featuredCarousel.vue?vue&type=style&index=2&id=0421ede7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421ede7",
  null
  
)

export default component.exports